import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full min-h-screen bg-h-primary-50 pb-1" }
const _hoisted_2 = { class: "pt-16 container mx-auto" }
const _hoisted_3 = { class: "bg-white my-5 shadow-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListCourses = _resolveComponent("ListCourses")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Cursos",
            en: "Courses",
          })), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ListCourses)
      ])
    ])
  ]))
}